import styles from './OrderFrame.module.scss';
import rightArrow2 from '../../assets/rightArrow04.png';
import rightArrow3 from '../../assets/rightArrow05.png';
import imsiProduct from '../../assets/imsi/imsiProduct4.png';
import { isMobile } from 'react-device-detect';
import { useNavigate } from 'react-router-dom';
import axiosClient from '../../libs/axiosClient';
import { IOrderDataType } from '../../pages/OrderComplete/OrderComplete';
import { useTranslation } from 'react-i18next';

interface IPropsType {
  page?: string;
  orderData: IOrderDataType;
}
function OrderFrame(props: IPropsType) {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  return (
    <>
      {isMobile ? (
        <div className={styles.isMobile}>
          <div className={styles.orderDate}>
            <span>
              {props.orderData.order_date.substring(2, 10).replace(/-/gi, '.')}{' '}
              Payment
            </span>
            <div
              onClick={() =>
                navigate(`/orderDetail/${props.orderData.order_id}`)
              }
            >
              <span>See more</span>
              <img src={rightArrow2} alt="arrow" />
            </div>
          </div>
          <div className={styles.productWrap}>
            <div
              className={styles.productThumbWrap}
              onClick={() =>
                navigate(
                  `/productDetail/${props.orderData.products[0].product_id}`,
                )
              }
            >
              <img src={props.orderData.products[0].image} alt="thumbnail" />
            </div>
            <div className={styles.productInfoWrap}>
              <span>{props.orderData.order_id}</span>
              <span>{props.orderData.products[0].title}</span>
              <span>${props.orderData.total_price.toLocaleString()}</span>
            </div>
            <div
              className={styles.status}
              style={{
                borderColor:
                  props.orderData.pay_status == '결제대기' ||
                  props.orderData.pay_status == '결제완료' ||
                  props.orderData.pay_status == '배송대기'
                    ? '#F6F7F9'
                    : props.orderData.pay_status == '배송준비'
                    ? 'rgba(30, 166, 28, 0.18)'
                    : props.orderData.pay_status == '배송중'
                    ? '#B7E7BD'
                    : props.orderData.pay_status == '배송완료'
                    ? '#121842'
                    : props.orderData.pay_status == '주문취소'
                    ? '#DC0000'
                    : '',
                color:
                  props.orderData.pay_status == '결제대기' ||
                  props.orderData.pay_status == '결제완료' ||
                  props.orderData.pay_status == '배송대기'
                    ? '#999999'
                    : props.orderData.pay_status == '배송준비'
                    ? '#00BE35'
                    : props.orderData.pay_status == '배송중'
                    ? '#00BE35'
                    : props.orderData.pay_status == '배송완료'
                    ? '#141736'
                    : props.orderData.pay_status == '주문취소'
                    ? '#DC0000'
                    : '',
                backgroundColor:
                  props.orderData.pay_status == '결제대기' ||
                  props.orderData.pay_status == '결제완료' ||
                  props.orderData.pay_status == '배송대기'
                    ? '#F6F7F9'
                    : 'white',
              }}
            >
              {props.orderData.pay_status == '결제대기'
                ? t('myPage.7')
                : props.orderData.pay_status == '결제완료' ||
                  props.orderData.pay_status == '배송대기'
                ? t('myPage.8')
                : props.orderData.pay_status == '배송준비'
                ? t('myPage.9')
                : props.orderData.pay_status == '배송중'
                ? t('myPage.10')
                : props.orderData.pay_status == '배송완료'
                ? t('myPage.11')
                : props.orderData.pay_status == '주문취소'
                ? t('myPage.13')
                : ''}
            </div>
          </div>
        </div>
      ) : (
        <div
          className={`${styles.isPC} ${
            props.page == 'myPage' ? styles.secondDesign : ''
          }`}
        >
          <div className={styles.orderInfo}>
            <span>
              {props.orderData.order_date.substring(0, 10).replace(/-/gi, '.')}
            </span>
            <span>{props.orderData.order_id}</span>
          </div>
          <div className={styles.productInfo}>
            <div
              className={styles.productThumbWrap}
              onClick={() =>
                navigate(
                  `/productDetail/${props.orderData.products[0].product_id}`,
                )
              }
            >
              <img src={props.orderData.products[0].image} alt="thumbnail" />
            </div>
            <span>{props.orderData.products[0].title}</span>
          </div>
          <span className={styles.price}>
            ${props.orderData.total_price.toLocaleString()}
          </span>
          <div className={styles.statusWrap}>
            <div
              className={styles.status}
              style={{
                borderColor:
                  props.orderData.pay_status == '결제대기' ||
                  props.orderData.pay_status == '결제완료' ||
                  props.orderData.pay_status == '배송대기'
                    ? '#F6F7F9'
                    : props.orderData.pay_status == '배송준비'
                    ? 'rgba(30, 166, 28, 0.18)'
                    : props.orderData.pay_status == '배송중'
                    ? '#B7E7BD'
                    : props.orderData.pay_status == '배송완료'
                    ? '#121842'
                    : props.orderData.pay_status == '주문취소'
                    ? '#DC0000'
                    : '',
                color:
                  props.orderData.pay_status == '결제대기' ||
                  props.orderData.pay_status == '결제완료' ||
                  props.orderData.pay_status == '배송대기'
                    ? '#999999'
                    : props.orderData.pay_status == '배송준비'
                    ? '#00BE35'
                    : props.orderData.pay_status == '배송중'
                    ? '#00BE35'
                    : props.orderData.pay_status == '배송완료'
                    ? '#141736'
                    : props.orderData.pay_status == '주문취소'
                    ? '#DC0000'
                    : '',
                backgroundColor:
                  props.orderData.pay_status == '결제대기' ||
                  props.orderData.pay_status == '결제완료' ||
                  props.orderData.pay_status == '배송대기'
                    ? '#F6F7F9'
                    : 'white',
              }}
            >
              {props.orderData.pay_status == '결제대기'
                ? t('myPage.7')
                : props.orderData.pay_status == '결제완료' ||
                  props.orderData.pay_status == '배송대기'
                ? t('myPage.8')
                : props.orderData.pay_status == '배송준비'
                ? t('myPage.9')
                : props.orderData.pay_status == '배송중'
                ? t('myPage.10')
                : props.orderData.pay_status == '배송완료'
                ? t('myPage.11')
                : props.orderData.pay_status == '주문취소'
                ? t('myPage.13')
                : ''}
            </div>
            <img
              src={rightArrow3}
              alt="arrow"
              onClick={() =>
                navigate(`/orderDetail/${props.orderData.order_id}`)
              }
            />
          </div>
        </div>
      )}
    </>
  );
}
export default OrderFrame;
